/**
 * App version constant - used for Firebase Analytics tracking and Credits display
 * Update this value for each release
 */

export const APP_VERSION = "5.0.241";
